module.exports = __webpack_public_path__ + "img/516fca90-d687-11e8-828a-1334c9ae6ae8-image.604700d8.jpg";